export function getBrowserName() {
  const userAgent = navigator.userAgent;
  let browserName = 'Unknown';

  if (userAgent.indexOf("Firefox") > -1) {
    browserName = "Firefox";
  } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    browserName = "Opera";
  } else if (userAgent.indexOf("Trident") > -1) {
    browserName = "Internet Explorer";
  } else if (userAgent.indexOf("Edge") > -1) {
    browserName = "Edge";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browserName = "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    browserName = "Safari";
  }

  return browserName;
}

export function getOSName() {
  const platform = navigator.platform.toLowerCase();

  if (platform.indexOf('win') !== -1) {
    return 'Windows';
  } else if (platform.indexOf('mac') !== -1) {
    return 'Mac OS';
  } else if (platform.indexOf('linux') !== -1) {
    return 'Linux';
  } else if (/android/.test(navigator.userAgent.toLowerCase())) {
    return 'Android';
  } else if (/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())) {
    return 'iOS';
  } else {
    return 'Unknown';
  }
}